import { Component, OnInit } from '@angular/core';
import { VoiceRecognitionService } from '../voiceclips/services/voice-recognition.service';

@Component({
  selector: 'app-journal',
  templateUrl: './journal.component.html',
  styleUrls: ['./journal.component.css']
})
export class JournalComponent implements OnInit {

  isOctober: boolean = true;
  isMicOn: boolean = false;
  search: string = '';
  constructor(public voiceRecognitionService: VoiceRecognitionService) { }

  ngOnInit(): void {
    this.voiceRecognitionService.init();
  }

  showOctober(){
    if (this.search.toLowerCase() === 'october'){
      this.isOctober = false;
    }
    else{
      this.isOctober = true;
    }
  }

  startService() {
    this.voiceRecognitionService.start();
  }

  stopService() {
    this.voiceRecognitionService.stop();
  }

  micMechanism(){
    if (this.isMicOn){
      this.stopService()
      this.isMicOn = !this.isMicOn;
    }
    else{
      this.isMicOn = !this.isMicOn;
      this.startService();
    }
  }

}
